/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { user } from '../common/user';

export class alert extends IceEntity {
  alert_key: string = "";
  reminder_key: string = "";
  alert_type: IceTypes.ALERTTYPE = IceTypes.ALERTTYPE.alertSystem;
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_account: string = "";
  alert_date: any = NaN;
  treatment_plan_key: string = "";
  management_guideline_key: string = "";
  disabled: boolean = false;
  title: string = "";
  description: string = "";
  overridden: boolean = false;
  override_reason: string = "";
  severity_type: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  USERS: user[] = [];

  gettablename(): string {
      return "ALERT";
  }

  hassubtree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "USERS") return true;

      return false;
  }

  getsubtreetablename(ColumnName: string): string {
      if (ColumnName.length == 0) return null;
      else if (ColumnName == "USERS") return "USER_TRANS_ACCOUNT";

      return null;
  }
}
